import { useState, useEffect } from 'react';
import { Grid, Typography, Paper, InputBase, IconButton } from '@mui/material';
import { AdjustRounded, DeleteOutlineRounded, AddRounded } from '@mui/icons-material';
import { grey, red } from '@mui/material/colors';
import AddLinkDialog from '../AddLinkDialog';
import ShortcutItem from './ShortcutItem';
import { v4 } from 'uuid';

export default function ShortcutBar({ data, editable, onEdit, onDelete, forPortal, portalSpaceId }) {
  const [title, setTitle] = useState('');
  const [dialog, setDialog] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!data) return;
    setTitle(data.title);
    setItems(data.items);
  }, [data]);

  function addShortcut(shortcut) {
    items.push({ data: shortcut, id: v4(), type: 'shortcut' });
    setItems([...items]);
    onEdit({ title, items });
  }

  function deleteItem(id) {
    const remaining = items.filter((x) => x.id !== id);
    setItems(remaining);
    onEdit({ title, items: remaining });
  }

  function editItem(itemId, update) {
    const index = items.findIndex((x) => x.id === itemId);
    if (index === -1) return;
    items[index].data = { ...items[index].data, ...update };
    onEdit({ title, items });
  }

  return (
    <Grid container style={{ height: '100%', position: 'relative' }}>
      <Grid
        container
        direction="column"
        style={{
          height: '100%',
          position: 'absolute',
          right: 0,
          top: 0,
          padding: 8,
        }}
      >
        <Grid container item alignItems="center" wrap="nowrap" style={{ padding: 8 }}>
          <AdjustRounded style={{ color: grey[500] }} />
          {editable ? (
            <InputBase
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                onEdit({ title: e.target.value, items });
              }}
              onMouseDown={(e) => e.stopPropagation()}
              placeholder="Enter title"
              inputProps={{ maxLength: 256, style: { fontSize: 20 } }}
              style={{ marginLeft: 16, fontSize: 20 }}
            />
          ) : (
            <Typography style={{ marginLeft: 16, fontSize: 20 }}>{title}</Typography>
          )}
          {editable && (
            <>
              <IconButton color="primary" style={{ marginLeft: 'auto' }} onClick={() => setDialog(true)}>
                <AddRounded />
              </IconButton>
              <AddLinkDialog
                open={dialog}
                onClose={() => setDialog(false)}
                forDashboard
                onResult={addShortcut}
                forPortal={forPortal}
              />
              <IconButton onClick={(e) => onDelete()}>
                <DeleteOutlineRounded style={{ color: red[500] }} />
              </IconButton>
            </>
          )}
        </Grid>

        <Grid
          container
          item
          alignItems="center"
          style={{ marginTop: 16, padding: 8, overflow: 'auto', flex: 1 }}
          alignContent="flex-start"
        >
          {items.map((item) => (
            <Grid item container key={item.id} lg={3} md={4} xs={6} style={{ padding: 4 }}>
              <Paper variant="outlined" style={{ borderRadius: 8, border: `2px solid ${grey[300]}`, width: '100%' }}>
                <ShortcutItem
                  editable={editable}
                  item={item.data}
                  onDelete={() => deleteItem(item.id)}
                  onChange={(update) => editItem(item.id, update)}
                  portalSpaceId={portalSpaceId}
                />
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
